/**
 * UserLink Component
 * 
 * Displays a user's name with a clickable alias link to Phone Tool
 */

import Link from '@cloudscape-design/components/link';
import { phoneToolUrl } from '../lib/externalUrls';

interface UserLinkProps {
  userName: string;
  userId: string;
}

export function UserLink({ userName, userId }: UserLinkProps) {
  return (
    <>
      {userName} (
      <Link
        href={phoneToolUrl(userId)}
        external
      >
        @{userId}
      </Link>
      )
    </>
  );
}
